// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"h1-z","subtitle":"i1-z","wrapper":"j1-z","leftArrow":"k1-z","rightArrow":"l1-z"};